// Tenant configuration for Mecklenburg-Vorpommern (mv).
import { TenantConfig } from '@/tenants/types'

export const tenant: TenantConfig = {
  id: 'mv',
  name: 'Fifty-Fifty-Taxi Mecklenburg-Vorpommern',
  copyright: 'Copyright 2024-{currentYear} Mecklenburg-Vorpommern (WM)',
  deleteAccountMailSubject: '5050 Taxi Mecklenburg-Vorpommern - Anfrage Kontolöschung',
}
